import { getMusics, removeUserMusic } from "../../api/music";
import {
  setIdle,
  setImageLoading,
  setLoading,
} from "../../store/common/appStateSlice";
import { setMusics } from "../../store/media/mediaSlice";
import { setUserAudioData } from "../../store/script/scriptSlice";

export const loadMusics = () => async (dispatch) => {
  try {
    dispatch(setImageLoading());
    const data = await getMusics();
    dispatch(setMusics(data));
    dispatch(setIdle());
  } catch (error) {
    console.error("Error loading musics:", error);
    // Handle the error state appropriately
    dispatch(setIdle());
  }
};

export const removeMusic = (id, isAudio) => async (dispatch, getState) => {
  try {
    dispatch(setLoading());
    await removeUserMusic(id);
    if (!isAudio) {
      const musics = getState().media.musics;
      dispatch(setMusics(musics.filter((i) => i.id !== id)));
    } else {
      const audio = getState().script.userAudioScript;
      dispatch(setUserAudioData(audio.filter((i) => i.id !== id)));
    }
    dispatch(setIdle());
  } catch (error) {
    console.log(error);
    dispatch(setIdle());
  }
};
